export const FETCH_DETAILS = 'sms/reminder/details';
export const FETCH_DETAILS_SUCCESS = 'sms/reminder/details_success';
export const FETCH_DETAILS_FAILED = 'sms/reminder/details_failed';

export const FETCH_LIST = 'sms/reminder/list';
export const FETCH_LIST_SUCCESS = 'sms/reminder/list_success';
export const FETCH_LIST_FAILED = 'sms/reminder/list_failed';

export const CREATE = 'sms/reminder/create';
export const CREATE_SUCCESS = 'sms/reminder/create_success';
export const CREATE_FAILED = 'sms/reminder/create_failed';

export const UPDATE = 'sms/reminder/update';
export const UPDATE_SUCCESS = 'sms/reminder/update_success';
export const UPDATE_FAILED = 'sms/reminder/update_failed';

export const UPDATE_STATUS = 'sms/reminder/update_status';
export const UPDATE_STATUS_SUCCESS = 'sms/reminder/update_status_success';
export const UPDATE_STATUS_FAILED = 'sms/reminder/update_status_failed';

export const DELETE = 'sms/reminder/delete';
export const DELETE_SUCCESS = 'sms/reminder/delete_success';
export const DELETE_FAILED = 'sms/reminder/delete_failed';

export const BULK = 'sms/reminder/bulk';
export const BULK_SUCCESS = 'sms/reminder/bulk_success';
export const BULK_FAILED = 'sms/reminder/bulk_failed';

export const CLEAR_DATA = 'sms/clear_data';

export type SmsAction =
  | typeof FETCH_DETAILS
  | typeof FETCH_DETAILS_FAILED
  | typeof FETCH_DETAILS_SUCCESS
  | typeof FETCH_LIST
  | typeof FETCH_LIST_FAILED
  | typeof FETCH_LIST_SUCCESS
  | typeof CREATE
  | typeof CREATE_FAILED
  | typeof CREATE_SUCCESS
  | typeof UPDATE
  | typeof UPDATE_FAILED
  | typeof UPDATE_SUCCESS
  | typeof DELETE
  | typeof DELETE_FAILED
  | typeof DELETE_SUCCESS
  | typeof BULK
  | typeof BULK_FAILED
  | typeof BULK_SUCCESS;
